import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import axios from 'axios'
import VueAxios from 'vue-axios'

import Vuex from 'vuex'

import { SnackbarService } from 'vue3-snackbar'
import 'vue3-snackbar/styles'

const app = createApp(App)

const serverUrl = 'https://parkinguser-api.cloudpark.com.br'
// const serverUrl = 'http://127.0.0.1:5001'

axios.defaults.baseURL = `${serverUrl}/api/`

app.use(VueAxios, axios)

app.use(Vuex)
app.use(store)

app.use(router)

app.use(SnackbarService)

app.mount('#app')
